// Staff Getters

export const getStaffList = state => {
  return state.staffList
}

export const getStaffMemberInfo = state => {
  return state.staffMemberInfo
}

export const getStaffMemberSubOutlet = state => {
  return state.staffMemberSubOutlet
}

export const getGenderList = state => {
  return state.genderList
}

export const getMaritalStatusList = state => {
  return state.maritalStatusList
}

export const getStaffMemberRole = state => {
  return state.staffMemberRole
}

export const getBloodGroupsList = state => {
  return state.bloodGroupsList
}

export const getAllPermissionsList = state => {
  return state.allPermissionsList
}

export const getFullStaffsList = state => {
  return state.fullStaffsList
}

export const getFullOutletStaffsList = state => {
  return state.fullOutletStaffsList
}
